import { useAuthStore } from '@stores/auth'
import { useProfileStore } from '@stores/profile'

import { useProfileApi } from '@api/profile/profile.hook'
import { usePrivilegesApi } from '@api/profile/privileges.hook'

export const useMiddlewareProfile = async (): Promise<void> => {
  const auth = useAuthStore()
  const profile = useProfileStore()

  if (!auth.isAuthenticated) return

  if (!profile.hasUser) {
    const { fetchProfile } = useProfileApi()
    await fetchProfile()
    return
  }

  if (!profile.privileges) {
    await usePrivilegesApi()
  }
}
